import { Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Box, Container, Grid } from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  AutoCompleteWithSearch,
  ColorPickerInput,
  FormCard,
  FormLabel,
  FormUploadImage,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  PrimaryDeleteButton,
  SecondaryButton,
  SectionLabel,
  SelectInput,
  SkeletonComponent,
  SwitchInput,
  TextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import ModalTransactionDsp from "./Components/ModalTransactionDsp";

const FormParameterPublisher = ({ userLogin }) => {
  const classes = globalStyles();
  const history = useHistory();
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const pageTitle = `${id ? "Edit" : "Add"} Publisher`;
  const userRole = userLogin?.role?.type;
  const restrictedForm = userRole !== "society" && userRole !== "association";

  const [loadingPage, setLoadingPage] = useState(false);
  const [optionCountry, setOptionCountry] = useState([]);
  const [optionAssociation, setOptionAssociation] = useState([]);
  const [optionDsp, setOptionDsp] = useState([]);
  const [optionTerritory, setOptionTerritory] = useState([]);
  const [optionSociety, setOptionSociety] = useState([]);
  const [optionUserRole, setOptionUserRole] = useState([]);

  const [payload, setPayload] = useState({
    name: "",
    is_member: 1,
    subdomain: "",
    email: "",
    country_id: "",
    association_id: "",
    ipi_name_number: "",
    ipi_base_number: "",
    publisher_code: "",
    phone: "",
    address: "",
    theme_color: "#000000",
    publisher_affiliations: [initSocietyField],
    user_role: [],
    allow_composer_request_payment: false,
    view_all_dsp: false,
  });
  const [queryParams, setQueryParams] = useState({
    search: "",
  });
  const [publisherLogo, setPublisherLogo] = useState({
    image_url: null,
    image: null,
  });
  const [modalVisible, setModalVisible] = useState(false);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleAddSociety = () =>
    setPayload(prev => ({
      ...prev,
      publisher_affiliations: [
        ...prev?.publisher_affiliations,
        initSocietyField,
      ],
    }));
  const handleChangeSelectedSociety = (value, key, index) =>
    setPayload(prev => ({
      ...prev,
      publisher_affiliations: prev?.publisher_affiliations?.map((item, i) =>
        i === index ? { ...item, [key]: value } : item
      ),
    }));
  const handleRemoveSociety = index =>
    setPayload(prev => ({
      ...prev,
      publisher_affiliations: prev?.publisher_affiliations?.filter(
        (_, i) => i !== index
      ),
    }));
  const handleSwitchDspTransaction = checked => {
    handleChangePayload(checked, "view_all_dsp");
    setOptionDsp(prev =>
      prev.map(item => ({
        ...item,
        is_active_flag: true,
      }))
    );
  };
  const handleSelectDspTransaction = (checked, index) => {
    setOptionDsp(prev =>
      prev.map((item, i) =>
        i === index ? { ...item, is_active_flag: checked } : item
      )
    );
  };

  const getOptionCountry = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/country/table`, {
        headers,
        params: {
          page: 1,
          per_page: 99,
          search: "",
          sort: "",
        },
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        label: item?.country_name,
      }));
      setOptionCountry(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getOptionAssociation = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/association/all`, {
        headers,
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        id: item?.association_id,
        label: item?.name,
      }));
      setOptionAssociation(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getOptionDsp = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/publishers/list/${id}/dsps`, {
        headers,
      });
      const { data } = res?.data;
      setOptionDsp(data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getOptionTerritory = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/admin/territory`, {
        headers,
        params: { page: 1, size: -1 },
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        label: item?.territory_code,
      }));
      setOptionTerritory(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getOptionSociety = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/admin/society/`, {
        headers,
        params: { page: 1, size: -1 },
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        label: item?.society_name,
      }));
      setOptionSociety(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };

  const getOptionUserRole = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/role?type=publisher`, {
        headers,
        params: { page: 1, size: -1 },
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        id: item?.role_id,
        label: item?.name,
      }));
      setOptionUserRole(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDetail = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/publisher/${id}`, {
        headers,
      });
      const { data } = res?.data;
      const requiredKeys = [
        "name",
        "email",
        "country_id",
        "association_id",
        "ipi_name_number",
        "ipi_base_number",
        "publisher_code",
        "phone",
        "address",
        "theme_color",
        "subdomain",
      ];
      const filteredData = requiredKeys?.reduce((acc, key) => {
        acc[key] = data[key];
        return acc;
      }, {});
      const userRoles = [];
      if (data?.publisher_user_roles) {
        data?.publisher_user_roles.map(item => {
          userRoles.push(item.role);
        });
      }
      setPayload({
        is_member: data?.is_member ? 0 : 1,
        image_logo: data?.profile_image,
        publisher_affiliations: data?.territories?.length
          ? data?.territories?.map(item => ({
              territory: item,
              society: item?.societies,
            }))
          : [initSocietyField],
        user_role: userRoles.length > 0 ? userRoles : [],
        allow_composer_request_payment:
          data?.publisher_config?.allow_composer_request_payment || false,
        view_all_dsp: data?.member?.view_all_dsp || false,
        ...filteredData,
      });
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getOptionCountry(), getOptionUserRole()];
    if (restrictedForm) {
      promises?.push(getOptionAssociation());
      promises?.push(getOptionTerritory());
      promises?.push(getOptionSociety());
    }
    if (id) {
      promises?.push(getDetail());
      promises?.push(getOptionDsp());
    }
    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const method = id ? axios.put : axios.post;
    const formData = new FormData();
    const {
      image_logo,
      is_member,
      publisher_affiliations,
      user_role,
      ...restPayload
    } = payload;
    const modifiedPayload = {
      ...restPayload,
      is_member: Boolean(is_member === 0),
    };
    Object.entries(modifiedPayload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    publisher_affiliations?.forEach(({ territory, society }) => {
      formData.append(
        "publisher_affiliations",
        JSON.stringify({
          territory_id: territory?.id,
          society_id: society?.map(({ id }) => id) || [],
        })
      );
    });
    formData.append(
      "role_ids",
      user_role?.map(({ role_id }) => [role_id]) || []
    );
    if (id) {
      optionDsp.forEach(item => {
        formData.append("dsp_ids", item?.dsp_id || "");
        formData.append("is_active_flags", item?.is_active_flag || false);
      });
    }
    if (publisherLogo?.image || !image_logo) {
      formData.append("image_logo", publisherLogo?.image || "");
    }
    try {
      setLoadingPage(true);
      await method(`${hardBaseUrl}/publisher${id ? `/${id}` : ""}`, formData, {
        headers,
      });
      ModalSuccess(`Succesfully ${id ? "update" : "save"} publisher`).then(() =>
        history.goBack()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Page className={classes.root} title={pageTitle}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={pageTitle}
            breadcrumbData={breadcrumbData({ pageTitle })}
            backButton
          />
          <Divider className={classes?.divider} />
          <Grid container columnSpacing={3}>
            <Grid item xs={12} md={6}>
              <SectionLabel
                title="Profile Publisher"
                subTitle="Customize publisher profile and URL to share"
              />
              <FormCard>
                <Grid container direction="column" rowSpacing={1}>
                  {MockFieldForm({ optionCountry, optionAssociation }).map(
                    ({
                      key,
                      title,
                      required,
                      type,
                      endAdorment,
                      options,
                      multiline,
                      rows,
                    }) => (
                      <Grid item key={key}>
                        <FormLabel label={title} required={required} />
                        {type === "select" ? (
                          <SelectInput
                            options={options}
                            optionKey="id"
                            optionLabel="label"
                            value={payload?.[key]}
                            onChange={e =>
                              handleChangePayload(e?.target?.value, key)
                            }
                            width="100%"
                          />
                        ) : type === "autocomplete" ? (
                          <AutoCompleteComponent
                            placeholder={title}
                            options={options}
                            value={
                              options?.find(
                                option => option?.id === Number(payload?.[key])
                              ) || null
                            }
                            onChange={e => handleChangePayload(e, key)}
                            size="small"
                            width="100%"
                          />
                        ) : (
                          <TextInput
                            placeholder={title}
                            value={payload?.[key]}
                            endAdornment={endAdorment}
                            onChange={e =>
                              handleChangePayload(e?.target?.value, key)
                            }
                            multiline={multiline}
                            rows={rows}
                          />
                        )}
                      </Grid>
                    )
                  )}
                </Grid>
              </FormCard>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container direction="column">
                <Grid item>
                  <SectionLabel
                    title="Appearance"
                    subTitle="Choose your company logo and customize the color theme"
                  />
                  <FormCard>
                    <FormUploadImage
                      label="Publisher Logo"
                      required
                      imageUrl={publisherLogo.image_url || payload?.image_logo}
                      setImageLogo={setPublisherLogo}
                    />
                    <Box mt="16px">
                      <FormLabel label="Theme Color" required />
                      <ColorPickerInput
                        value={payload?.theme_color}
                        onChange={color =>
                          handleChangePayload(color, "theme_color")
                        }
                      />
                    </Box>
                  </FormCard>
                </Grid>
                {id && (
                  <Grid item>
                    <SectionLabel
                      title="View Transaction DSP Publisher"
                      subTitle="Feature to set view DSP Publisher"
                    />
                    <FormCard>
                      <Grid container justifyContent="space-between">
                        <Grid item my="6px">
                          <SwitchInput
                            checked={payload?.view_all_dsp}
                            onChange={e =>
                              handleSwitchDspTransaction(e?.target?.checked)
                            }
                            label="View All DSP Transaction"
                          />
                        </Grid>
                        {!payload?.view_all_dsp && (
                          <Grid item>
                            <PrimaryButton
                              label="Setting DSP"
                              onClick={() => setModalVisible(true)}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </FormCard>
                  </Grid>
                )}
                {restrictedForm && (
                  <Grid item>
                    <Grid container justifyContent="space-between">
                      <Grid item>
                        <SectionLabel
                          title="Society"
                          subTitle="Input your society fee for the data requirement"
                        />
                      </Grid>
                      {payload?.publisher_affiliations?.length < 5 && (
                        <Grid item>
                          <SecondaryButton
                            startIcon={<Add />}
                            label="Add Society"
                            onClick={handleAddSociety}
                          />
                        </Grid>
                      )}
                    </Grid>
                    {payload?.publisher_affiliations?.map(
                      ({ territory, society, search }, index) => (
                        <FormCard key={index}>
                          <Grid container direction="column" rowGap={2}>
                            <Grid item>
                              <FormLabel label="Territory" />
                              <AutoCompleteComponent
                                options={optionTerritory}
                                value={
                                  optionTerritory.find(
                                    option => option.id === territory?.id
                                  ) || null
                                }
                                onChange={e =>
                                  handleChangeSelectedSociety(
                                    optionTerritory.find(
                                      option => option.id === e
                                    ),
                                    "territory",
                                    index
                                  )
                                }
                                placeholder="Select Territory"
                                size="small"
                                width="100%"
                              />
                            </Grid>
                            <Grid item>
                              <FormLabel label="Society" />
                              <AutoCompleteWithSearch
                                multiple
                                disableCloseOnSelect
                                autoHighlight
                                options={optionSociety.filter(society =>
                                  society?.society_name
                                    .toLowerCase()
                                    .includes(search?.toLowerCase())
                                )}
                                optionLabel="society_name"
                                placeholder="Select Society"
                                value={society}
                                onChange={e =>
                                  handleChangeSelectedSociety(
                                    e,
                                    "society",
                                    index
                                  )
                                }
                                inputValue={search}
                                onInputChange={e =>
                                  handleChangeSelectedSociety(
                                    e,
                                    "search",
                                    index
                                  )
                                }
                                width="100%"
                              />
                            </Grid>
                            {payload?.publisher_affiliations?.length > 1 && (
                              <Grid item>
                                <Grid container justifyContent="right">
                                  <PrimaryDeleteButton
                                    onClick={() => handleRemoveSociety(index)}
                                  />
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </FormCard>
                      )
                    )}
                  </Grid>
                )}
                <Grid item>
                  <Grid container justifyContent="space-between">
                    <Grid item>
                      <SectionLabel
                        title="User Role"
                        subTitle="Input your user role for access application menu"
                      />
                    </Grid>
                  </Grid>
                  <FormCard>
                    <Grid container direction="column" rowGap={2}>
                      <Grid item>
                        <FormLabel label="User Role" required />
                        <AutoCompleteWithSearch
                          multiple
                          disableCloseOnSelect
                          autoHighlight
                          options={optionUserRole.filter(item =>
                            item?.name
                              .toLowerCase()
                              .includes(queryParams?.search?.toLowerCase())
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option?.role_id === value?.role_id
                          }
                          value={payload?.user_role}
                          onChange={value =>
                            handleChangePayload(value, "user_role")
                          }
                          inputValue={queryParams?.search}
                          onInputChange={value =>
                            handleChangeQueryParams(value, "search")
                          }
                          optionLabel="name"
                          placeholder="Search Role Name"
                          width="100%"
                        />
                      </Grid>
                    </Grid>
                  </FormCard>
                </Grid>
                <Grid item>
                  <Grid container justifyContent="space-between">
                    <Grid item>
                      <SectionLabel
                        title="Payment Configuration"
                        subTitle="If disabled, all composer under this publisher cannot submit payment requests."
                      />
                    </Grid>
                  </Grid>
                  <FormCard>
                    <SwitchInput
                      checked={payload?.allow_composer_request_payment}
                      onChange={e =>
                        handleChangePayload(
                          e?.target?.checked,
                          "allow_composer_request_payment"
                        )
                      }
                      label="
                      Allow Composer Payment Request"
                    />
                  </FormCard>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent="right">
            <PrimaryButton label="Save" onClick={handleSubmit} />
          </Grid>
        </Container>
      )}
      <ModalTransactionDsp
        open={modalVisible}
        onClose={() => setModalVisible(false)}
        optionDsp={optionDsp}
        handleSelectDspTransaction={handleSelectDspTransaction}
      />
    </Page>
  );
};

const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Parameter",
    link: "/admin/parameter/publisher",
  },
  {
    label: "Publisher",
    link: "/admin/parameter/publisher",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const optionStatus = [
  {
    id: 0,
    label: "Member",
  },
  {
    id: 1,
    label: "Non-Member",
  },
];
const MockFieldForm = ({ optionCountry, optionAssociation }) => [
  {
    title: "Profile Publisher Name",
    key: "name",
    required: true,
  },
  {
    title: "Status",
    key: "is_member",
    options: optionStatus,
    type: "select",
  },
  {
    title: "URL",
    key: "subdomain",
    endAdorment: ".caris.id",
  },
  {
    title: "Email",
    key: "email",
    required: true,
  },
  {
    title: "Country",
    key: "country_id",
    required: true,
    options: optionCountry,
    type: "autocomplete",
  },
  {
    title: "Association",
    key: "association_id",
    options: optionAssociation,
    type: "autocomplete",
  },
  {
    title: "IPI Name Number",
    key: "ipi_name_number",
    required: true,
  },
  {
    title: "IPI Base Number",
    key: "ipi_base_number",
  },
  {
    title: "Transmitter Code",
    key: "publisher_code",
  },
  {
    title: "Phone Number",
    key: "phone",
    required: true,
  },
  {
    title: "Address",
    key: "address",
    required: true,
    multiline: true,
    rows: 4,
  },
];
const initSocietyField = { territory: "", society: [], search: "" };
export default FormParameterPublisher;
